export const GET_ADMIN_CONCIERGES = 'GET_ADMIN_CONCIERGES'
export const GET_ADMIN_SINGLE_CONCIERGE = 'GET_ADMIN_SINGLE_CONCIERGE'